import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-po-ledger-total",
  templateUrl: "./po-ledger-total.component.html",
  styleUrls: ["./po-ledger-total.component.scss"]
})
export class PoLedgerTotalComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
